var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-icon-btn',_vm._g(_vm._b({staticClass:"read-status__button",attrs:{"loading":_vm.loading}},'app-icon-btn',_vm.$attrs,false),_vm.$listeners),[_c('div',{class:{ 'read-status__dot': true, 'read-status__dot--unread': _vm.isUnread }})])}
var staticRenderFns = []

export { render, staticRenderFns }